import administration from './routes'

export default [...administration] as const
